import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'
import createReactClass from 'create-react-class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'

import { withGettext } from 'lib/gettext'

import { BranchMixin, SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ResolveMixin } from 'legacy/libs/baobab-react-resolver'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'
import entryTagApi from 'legacy/api/entry-tag'

import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import { Role, hasAnyRole } from 'auth'
import { AuthorizedFragment } from 'common'
import TagsAncestry from '../tags-ancestry'
import AddTagButton from '../add-tag-button'

import s from './selected-tags.module.scss'

const SelectedTag = withGettext(
  createReactClass({
    displayName: 'SelectedTag',
    mixins: [SchemaBranchMixin, ResolveMixin],

    propTypes: {
      gettext: PropTypes.func.isRequired,
      onDelete: PropTypes.func,
      approveService: PropTypes.func,
      refuseService: PropTypes.func,
      groupsCursor: BaobabPropTypes.cursor,
      selectedTagsCursor: BaobabPropTypes.cursor,
      tree: PropTypes.oneOfType([
        BaobabPropTypes.baobab,
        BaobabPropTypes.cursor,
      ]),
    },

    schema: {
      name: null,
      pk: null,
      approved: false,
      ancestry: [],
      relatedTags: {},
    },

    getResolverBindings() {
      if (!this.props.groupsCursor) {
        return []
      }

      return [
        {
          cursor: this.cursors.relatedTags,
          service: () => entryTagApi.getRelatedTagsByTag(this.state.pk),
          initialData: [],
          alwaysLoad: true,
        },
      ]
    },

    getFilteredRelatedTags() {
      if (!this.state.relatedTags) {
        return []
      }

      const relatedTags = this.state.relatedTags.data
      const selectedTagsPks = this.props.selectedTagsCursor.map((tag) =>
        tag.get('pk')
      )

      return _.filter(
        relatedTags,
        (relatedTag) => !_.includes(selectedTagsPks, relatedTag.pk)
      )
    },

    getTagCursor(pk) {
      return _.first(
        _.filter(
          this.cursors.relatedTags.select('data').map(_.identity),
          (tagCursor) => tagCursor.get('pk') === pk
        )
      )
    },

    onDeleteClick() {
      this.props.tree.once('update', () => this.props.onDelete())
      this.props.tree.unset()
    },

    onApproveClick() {
      this.props.approveService(this.state.pk).then(() => {
        this.cursors.approved.set(true)
      })
    },

    onRejectClick() {
      this.props.refuseService(this.state.pk).then(() => {
        this.onDeleteClick()
      })
    },

    render() {
      const { gettext } = this.props
      const { approved, name, ancestry } = this.state
      const isPending = !approved
      const relatedTags = this.getFilteredRelatedTags()

      return (
        <section>
          <div className={s.container}>
            <div
              className={classNames(s.tag, {
                [s._pending]: isPending,
              })}
            >
              <span className={s.title}>{name}</span>

              <button onClick={this.onDeleteClick} type="button">
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  className={s.delete__btn}
                />
              </button>
            </div>

            <TagsAncestry ancestry={ancestry} />

            {isPending && (
              <AuthorizedFragment
                authorize={(user) =>
                  hasAnyRole(user, [Role.REGIONAL_EDITOR, Role.MANAGING_EDITOR])
                }
                fallback={
                  <span className={s.pending}>{gettext('Pending...')}</span>
                }
              >
                <div className={s.approve}>
                  <button
                    className={s.approve__btn}
                    onClick={this.onApproveClick}
                    type="button"
                  >
                    {gettext('Accept')}
                  </button>

                  <button
                    className={s.reject__btn}
                    onClick={this.onRejectClick}
                    type="button"
                  >
                    {gettext('Reject')}
                  </button>
                </div>
              </AuthorizedFragment>
            )}
          </div>

          {!_.isEmpty(relatedTags) && (
            <div className={classNames(s.container, s.relations)}>
              <span className={s.relations__label}>
                {gettext('Related tags')}:
              </span>

              <ul className={s.relations__list}>
                {_.map(relatedTags, (relatedTag, index) => (
                  <li
                    className={s.relations__relation}
                    key={`relation-${index}`}
                  >
                    <span className={s.title}>{relatedTag.name}</span>

                    <TagsAncestry ancestry={relatedTag.ancestry}>
                      <AddTagButton
                        tree={this.getTagCursor(relatedTag.pk)}
                        selectedTags={this.props.selectedTagsCursor}
                      />
                    </TagsAncestry>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </section>
      )
    },
  })
)

const SelectedTags = createReactClass({
  mixins: [BranchMixin, FormComponentMixin],

  schema: {
    selectedTags: [],
    groups: [],
  },

  propTypes: {
    gettext: PropTypes.func.isRequired,
  },

  cursors(props, context) {
    return {
      selectedTags: this.getCursor(props, context),
      ...(props.groupsCursor ? { groups: props.groupsCursor } : {}),
    }
  },

  onTagDelete() {
    this.setDirtyState()
  },

  renderTag(cursor) {
    return (
      <SelectedTag
        tree={cursor}
        selectedTagsCursor={this.cursors.selectedTags}
        onDelete={this.onTagDelete}
        key={cursor.hash}
        {...this.props}
      />
    )
  },

  render() {
    const { selectedTags, groups } = this.state
    const { selectedTags: selectedTagsCursor } = this.cursors

    if (groups) {
      return (
        <div>
          {_.map(groups, (group, index) => {
            const groupHasTags = _.includes(
              _.map(selectedTags, 'entryTagGroup'),
              group.pk
            )

            const selectedTagsCursors = _.orderBy(
              _.filter(
                selectedTagsCursor.map(_.identity),
                (tagCursor) => tagCursor.get('entryTagGroup') === group.pk
              ),
              (cursor) => cursor.get('level'),
              'asc'
            )

            return groupHasTags ? (
              <div key={index}>
                <p className={s.group}>
                  {this.props.gettext('From')} {group.name}
                </p>

                {selectedTagsCursors.map(this.renderTag)}
              </div>
            ) : null
          })}
        </div>
      )
    }

    return <div>{selectedTagsCursor.map(this.renderTag)}</div>
  },
})

export default withGettext(SelectedTags)
